<!--
 * @Author: your name
 * @Date: 2020-11-11 09:54:06
 * @LastEditTime: 2020-11-12 14:34:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/home/components/StoreDet/index.vue
-->
<template>
  <!-- 主题清单 -->
  <div>
    <div
      v-for="(item, index1) in retailHomepage"
      :key="index1"
      class="theme_con"
    >
      <div class="title_con">
        <div class="font16 colo087 font_weight400 line_height_22">
          {{ item.title }}
        </div>
        <div
          class="font12 title_col font_weight400 line_height_17"
          @click="goMore(item.id)"
        >
          查看更多
        </div>
      </div>
      <div class="product_middle">
        <div
          v-for="(i, index) in item.details"
          :key="index"
          :class="{ middle_item_left: index == 0 }"
          class="middle_item"
        >
          <product-ver
            :showShare="true"
            :productDetail="i"
            @showPoster="showPoster"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const ProductVer = () => import("../ProductVer");
export default {
  components: {
    ProductVer
  },
  data() {
    return {};
  },
  computed: {
    retailHomepage() {
      return this.$store.getters.retailHomepage;
    }
  },
  methods: {
    goMore(id) {
      this.$emit("goMore", id);
    },
    showPoster(productDetail) {
      this.$emit("showPoster", productDetail);
    }
  }
};
</script>
<style scoped>
.theme_con {
  background: #fff;
  margin: 0 12px 12px;
  border-radius: 12px;
  padding: 12px 0 16px;
  background-image: url("../../../../assets/home/theme_bg.png");
  background-size: 120px 123px;
  background-repeat: no-repeat;
  background-position: 38px 14px;
}
.title_con {
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
}
.title_col {
  color: #bf9264;
  padding: 2px 10px;
  border-radius: 12px;
  border: 1px solid #bf9264;
}
.theme_list {
  margin-top: 12px;
}
.product_middle {
  display: flex;
  align-items: center;
  overflow-y: hidden;
  flex-wrap: nowrap;
  margin-top: 12px;
  /* margin-left: 12px; */
}
.middle_item {
  margin-right: 10px;
  list-style: none;
}
.middle_item_left {
  margin-left: 10px;
}

.middle_item > .product {
  width: 130px;
}

.middle_item > .product_name {
  font-size: 10px;
}

.middle_item > .product_price {
  font-size: 10px;
}
</style>
